import $ from "jquery";
import { frontendLogger } from "../typescript/FrontendLogger";

window.$ = $;

import "./blocks/expandable-block.ts";
import "./blocks/teaser-block.ts";
import "./blocks/search-control-block.ts";
import "./blocks/search-result-block.ts";
import "./components/tabs.ts";
import "./components/multiselect-list.ts";
import "./components/form-range.ts";
import "./components/language-select.ts";
import "./components/topPersonalization.ts";
import "./components/organisation-selector.ts";
import "./components/scroll-top-top.ts";
import "./components/pagination.ts";
import "./pages/search-page.ts";
import "../click-tracking.js";
import "./pages/autocomplete-Search-page.ts";
import "../piwik.analytics.js";
import "../usercentrics-preferences.js";
import "../../../../vgr-client-code/code/components/CustomMailValidator/customEmailValidator";
import "../../../../vgr-client-code/code/components/KivBlockDetails/kivBlockDetails.ts";
import "../../../../vgr-client-code/code/components/IfeedList/ifeedSort.ts";

import "./validation-summary-navigation";

if (typeof window !== "undefined") {
	window.VgrFrontend = window.VgrFrontend || {};
	window.VgrFrontend.logger = frontendLogger;

	if (document.getElementById("search-result-map")) {
		import(/* webpackChunkName: "visuell-identitet-leaflet-map" */ "./components/leaflet-map.ts");
	}

	if (document.getElementById("SearchQuery")?.hasAttribute("data-organizationname")) {
		import(/* webpackChunkName: "visuell-identitet-organization-querycompletion" */ "./organizationsearch-querycompletion");
	}

	if (document.querySelector(".global-search, .mobile-search__field")) {
		import(/* webpackChunkName: "visuell-identitet-autocomplete-search" */ "./AutocompleteSearch.ts");
	}

	if (document.querySelector(".myImg, .imagepreview")) {
		import(/* webpackChunkName: "visuell-identitet-craftsman-search-page" */ "../CraftsmanSearchPage.js");
	}

	if (document.getElementById("RightsText") || document.querySelector(".clothing-hygiene-diagram-block")) {
		import(/* webpackChunkName: "visuell-identitet-basala-hygienrutiner" */ "../BasalaHygienrutiner/main.js");
	}

	if (document.querySelector(".EPiServerForms, form.EPiServerForms, [data-f-element-name]")) {
		import(/* webpackChunkName: "visuell-identitet-custom-email-validator" */ "../../../../vgr-client-code/code/components/CustomMailValidator/customEmailValidator");
	}

	if (document.querySelector(".kiv-block")) {
		import(/* webpackChunkName: "visuell-identitet-kiv-block-details" */ "../../../../vgr-client-code/code/components/KivBlockDetails/kivBlockDetails.ts");
	}
}
